"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var translate_1 = require("utils/translate");
var sok_ui_1 = require("@caddigital/sok-ui");
var participantsActions = require("@caddigital/sok-reducers/lib/actions/bid/participants");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Types = require("types");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        usersGroups: state.bid.userGroups.list,
        selectedLanguage: selectedLanguage,
        selected: state.bid.participants.selected,
        toggleStatus: state.bid.participants.toggleStatus
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(participantsActions.toggleAddParticipant()); },
    toggleSelect: function (isSelected, user) {
        return dispatch(participantsActions.toggleSelect(isSelected, user));
    },
    removeParticipants: function (bid, group, selected) {
        return dispatch(participantsActions.removeRequest(bid, group, selected.map(function (_a) {
            var user = _a.user;
            return user;
        })));
    },
    disableParticipants: function (users, group, message) {
        return group &&
            dispatch(participantsActions.toggleUserFromGroup('DISABLE', users.map(function (_a) {
                var user = _a.user;
                return ({ user: user, groupId: group.id, message: message });
            })));
    },
    enableParticipants: function (users, group, message) {
        return group &&
            dispatch(participantsActions.toggleUserFromGroup('ENABLE', users.map(function (_a) {
                var user = _a.user;
                return ({ user: user, groupId: group.id, message: message });
            })));
    },
    toggleCopyModal: function () { return dispatch(participantsActions.toggleCopyParticipant()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var ParticipiantToggleContent = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "icon envelope-icon ".concat(props.toggleState.toLowerCase(), " fa-stack fa-2x") },
        React.createElement(sok_ui_1.Icon, { className: "fa-circle fa-stack-2x ".concat(props.toggleState === 'DISABLE' ? 'red' : 'green'), prefix: 'fal' }),
        React.createElement(sok_ui_1.Icon, { className: "fa-envelope fa-stack-1x", prefix: 'fa' })),
    React.createElement("div", { className: 'right-column' },
        React.createElement("h1", null, (0, translation_1.getLocalization)("participiantToggle/title/".concat(props.toggleState.toLowerCase()))),
        React.createElement("p", null, (0, translation_1.getLocalization)("participiantToggle/textBody1/".concat(props.toggleState.toLowerCase()))),
        React.createElement("p", null, (0, translation_1.getLocalization)("participiantToggle/textBody2/".concat(props.toggleState.toLowerCase()))),
        React.createElement("span", { className: 'reason' },
            React.createElement("p", null, (0, translation_1.getLocalization)("participiantToggle/reason/".concat(props.toggleState.toLowerCase()))),
            React.createElement("textarea", { onChange: function (e) {
                    return props.setState(__assign(__assign({}, props.state), { message: e.target.value }));
                } }))))); };
var ParticipiantToggleHeader = function (props) { return (React.createElement(React.Fragment, null, (0, translation_1.getLocalization)("participiantToggle/header/".concat(props.toggleState.toLowerCase())))); };
var ParticipiantToggleFooter = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('confirmDialog/confirmWithNotification'), color: 'green', disabled: props.toggleStatus === 'SAVING', onClick: function () {
            if (props.toggleState === 'DISABLE') {
                return props.disableParticipants(props.selected, props.usersGroups.find(function (g) { return g.type === 'ParticipantUserGroup'; }), props.state.message || '');
            }
            return props.enableParticipants(props.selected, props.usersGroups.find(function (g) { return g.type === 'ParticipantUserGroup'; }), props.state.message || '');
        } }),
    React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('confirmDialog/confirmWithoutNotification'), color: 'blue', disabled: props.toggleStatus === 'SAVING', onClick: function () {
            if (props.toggleState === 'DISABLE') {
                return props.disableParticipants(props.selected, props.usersGroups.find(function (g) { return g.type === 'ParticipantUserGroup'; }));
            }
            return props.enableParticipants(props.selected, props.usersGroups.find(function (g) { return g.type === 'ParticipantUserGroup'; }));
        } }),
    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('confirmDialog/cancel'), onClick: function () { return props.setIsOpen(false); } }))); };
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BidParticipantsTools'), (0, recompose_1.withState)('state', 'setState', {}), (0, recompose_1.withState)('toggleState', 'setToggleState', 'NONE'), (0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.withState)('removeIsOpen', 'setRemoveIsOpen', false), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.toggleStatus !== nextProps.toggleStatus &&
            nextProps.toggleStatus === 'SUCCESS') {
            nextProps.selected.forEach(function (u) { return nextProps.toggleSelect(false, u); });
            nextProps.setIsOpen(false);
        }
        if (this.props.selected !== nextProps.selected) {
            if (nextProps.selected.length > 0) {
                if (nextProps.selected.every(function (_a) {
                    var user = _a.user;
                    return user.disabled;
                })) {
                    nextProps.setToggleState('ENABLE');
                }
                else {
                    nextProps.setToggleState('DISABLE');
                }
            }
            else {
                nextProps.setToggleState('NONE');
            }
        }
    }
}), recompose_1.pure);
exports.Tools = enhance(function (props) {
    var now = Date.now();
    return (React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'briefcase-view-tools-container' },
        React.createElement(sok_ui_1.ToolsSidebar, { className: 'briefcaseView-tools', headerText: (0, translation_1.getLocalization)('bid/participantsView/tools/header') },
            React.createElement(sok_ui_1.ToolButton, { color: 'green', text: (0, translation_1.getLocalization)('bid/participantsView/tools/addParticipant'), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-user-plus' }), disabled: (props.currentBid.status === 'BID' &&
                    (props.currentBid.endAt || 0) < now) ||
                    (props.currentBid.procerement.preQualification &&
                        (props.currentBid.procerement.preQualificationDeadline || 0) <
                            now), onClick: function () { return props.toggleModal(); } }),
            React.createElement(sok_ui_1.ToolButton, { color: 'blue', text: (0, translation_1.getLocalization)('bid/participantsView/tools/addFromBid'), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-users-medical' }), disabled: (props.currentBid.status === 'BID' &&
                    (props.currentBid.endAt || 0) < now) ||
                    (props.currentBid.procerement.preQualification &&
                        (props.currentBid.procerement.preQualificationDeadline || 0) <
                            now), onClick: function () { return props.toggleCopyModal(); } }),
            !props.currentBid.status.includes('DRAFT') && (React.createElement(sok_ui_1.ToolButton, { color: 'gray', text: (0, translation_1.getLocalization)("bid/participantsView/tools/".concat(props.toggleState === 'ENABLE' ? 'enable' : 'disable')), icon: React.createElement(sok_ui_1.Icon, { className: props.toggleState === 'ENABLE'
                        ? 'fa-user-check'
                        : 'fa-user-alt-slash' }), disabled: props.toggleState === 'NONE', onClick: function () {
                    props.setState({ message: undefined });
                    props.setIsOpen(true);
                } })),
            props.currentBid.status.includes('DRAFT') && (React.createElement(sok_ui_1.ToolButton, { color: 'red', text: (0, translation_1.getLocalization)('bid/participantsView/tools/delete'), disabled: props.selected.length === 0, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-user-times' }), onClick: function () {
                    props.setRemoveIsOpen(true);
                } }))),
        React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.removeIsOpen, close: function () { return props.setRemoveIsOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                React.createElement(ConfirmDialog_1.Exclamation, null),
                React.createElement("div", null,
                    React.createElement("div", { className: 'title please-confirm-text' },
                        React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                    React.createElement("div", { className: 'text' },
                        React.createElement("p", null, (0, translation_1.getLocalization)('bid/participantsView/remove/areYouSure'))))), footer: React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                        if (props.usersGroups.length > 0) {
                            var group = props.usersGroups[0];
                            props.removeParticipants(props.currentBid, group, props.selected);
                            props.setRemoveIsOpen(false);
                        }
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setRemoveIsOpen(false); } })) }),
        React.createElement(ConfirmDialog_1.ConfirmDialog, { isOpen: props.isOpen, close: function () { return props.setIsOpen(false); }, className: 'bid-participants-confirm-dialog', header: React.createElement(ParticipiantToggleHeader, __assign({}, props)), body: React.createElement(ParticipiantToggleContent, __assign({}, props)), footer: React.createElement(ParticipiantToggleFooter, __assign({}, props)) })));
});
